import { form } from '../formState'

import { useTexts } from '../../hooks/useTexts'
import { createValidateCompanyName } from '../hooks/useFormValidation'

export function CompanyName() {
  const texts = useTexts()

  form.useAddFieldValidation<'companyName'>('companyName', async (field, _formApi) => {
    const companyNameValidation = await createValidateCompanyName(texts, field.value)
    return companyNameValidation.companyNameMaxLengthError?.message
  })

  return (
    <form.TextField
      name="companyName"
      label={texts.companyName}
      testId="companyName"
      validateOn="focus blur change"
    />
  )
}
